import { Link, createFileRoute } from "@tanstack/react-router"
// import { getAllPrizePurchaseHistory } from "@/queries/prizes"
// import { Button } from "@/components/ui/button"
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
// import type { ColumnDef, PaginationState } from "@tanstack/react-table"
// import { Check, Copy, X } from "lucide-react"
// import { useQuery } from "@tanstack/react-query"
// import { PrizesType, ProductTypes } from "@/types"
// import { DataTable } from "@/components/ui/data-table"
// import { useEffect, useState } from "react"
// import { toast } from "sonner"
// import { pointHistoryList } from "@/queries/points"
// import { operators } from "@/constants/operators"
// import OperatorsIcon from "@/components/OperatorIcons"
// import type { OperatorsName } from "@/stores/operator-store"
// import { convertDateTime } from "@/lib/utils"

export const Route = createFileRoute("/point/history/")({
  component: Closed,
})

function Closed() {
  return <>
    صفحه مورد نظر یافت نشد.
  </>
}

// function ClientPrizeHistory() {
//   const [pagination, setPagination] = useState<PaginationState>({pageIndex: 0, pageSize: 10})
//   const listQuery = useQuery({
//     queryFn: () => pointHistoryList(pagination.pageIndex + 1, pagination.pageSize),
//     queryKey: ['point', 'history', pagination]
//   })

//   const columns: ColumnDef<{
//     product_name: string,
//     type: keyof typeof ProductTypes,
//     point: number,
//     operator_id: number,
//     created_at: Date,
//   }>[] = [
//   {
//     header: 'اپراتور',
//     accessorKey: 'operator_id',
//     cell: ({row}) => {
//       const operator = operators.find(op => op.id == row.original.operator_id)

//       return <>
//         <OperatorsIcon operator={operator?.name as OperatorsName} operatorColors/>
//       </>
//     }
//   },
//     {
//       header: "نام محصول",
//       accessorKey: "product_name",
//       // cell: ({row}) => row.original.prize.name,
//     },
//     {
//       header: "نوع",
//       accessorKey: "type",
//       cell: ({
//         row: {
//           original: { type },
//         },
//       }) => ProductTypes[type],
//     },
//     {
//       header: "امتیاز",
//       accessorKey: "point",
//       cell: ({
//         row: {
//           original: { point },
//         },
//       }) => Intl.NumberFormat().format(point)
//     },
//     {
//         header: 'تاریخ دریافت',
//         accessorKey: 'created_at',
//         cell: ({row}) => convertDateTime(row.original.created_at) 
//     }
    
//   ]

//   return (
//     <>
//       <Card>
//         <div className="flex justify-between items-center pl-4">
//           <CardHeader>
//             <CardTitle>تاریخچه امتیازات دریافت شده</CardTitle>
//           </CardHeader>

//           <Link to="/client/prizes">
//             <Button>بازگشت</Button>
//           </Link>
//         </div>

//         <CardContent>
//           <DataTable<
//             any,
//             any
//           >
//             columns={columns}
//             data={listQuery.data?.data?.data ?? []}
//             pageCount={listQuery.data?.data?.meta.last_page}
//             pagination={pagination}
//             onPaginationChange={setPagination}
//           />
//         </CardContent>
//       </Card>
//     </>
//   )
// }
